import ModelBase, {IModelBase} from '@/models/ModelBase'
import * as dayjs from 'dayjs'
import Tag, {ITag} from '@/models/Tag'
import {IMedium, Medium} from '@/models/Medium'
import { KeyPair } from '@/types/KeyPair'

export type PostStatus = 'publish' | 'draft' | 'private'

export interface IPost extends IModelBase {
  title?: string
  publish_at: string
  status: PostStatus
  content?: string
  base_uri?: string
  link: string
  seo_title?: string
  seo_description?: string
  seo_ogp_title?: string
  seo_ogp_description?: string
  seo_ogp_image_url?: string
  seo_ogp_twitter_image_url?: string
  thumbnail?: IMedium
  tags: Array<ITag>

}

export default class Post extends ModelBase {
  title?: string
  publish_at?: string
  status: PostStatus = 'draft'
  content?: string
  base_uri: string
  _link: string
  seo_title?: string
  seo_description?: string
  seo_ogp_title?: string
  seo_ogp_description?: string
  seo_ogp_image_url?: string
  seo_ogp_twitter_image_url?: string
  thumbnail?: Medium
  tags: Array<Tag> = []

  constructor(defaults?: IPost) {
    super(defaults)
    if (defaults) {
      this.title = defaults.title || ''
      this.publish_at = dayjs(defaults.publish_at || new Date()).format('YYYY-MM-DDTHH:mm')
      this.status = defaults.status
      this.content = defaults.content || ''
      this.base_uri = defaults.base_uri
      this._link = defaults.link
      this.seo_title = defaults.seo_title
      this.seo_description = defaults.seo_description
      this.seo_ogp_title = defaults.seo_ogp_title
      this.seo_ogp_description = defaults.seo_ogp_description
      this.seo_ogp_image_url = defaults.seo_ogp_image_url
      this.seo_ogp_twitter_image_url = defaults.seo_ogp_twitter_image_url
      this.thumbnail = defaults.thumbnail ? new Medium(defaults.thumbnail) : undefined
      this.tags = defaults.tags?.map(t => new Tag(t)) || []
    }
  }

  get publishAtNumber(): number {
    switch (this.status) {
      case 'publish': return dayjs(this.publish_at).toDate().getTime()
      case 'draft': return 0
      case 'private': return -1
    }
  }

  get publishAtString(): string {
    switch (this.status) {
      case 'publish': return dayjs(this.publish_at).format('YYYY/MM/DD HH:mm')
      case 'draft': return '下書き'
      case 'private': return '非公開'
    }
  }

  get link(): string {
    return `${location.protocol}//${location.host}${this._link}`
  }

  get previewLink(): string {
    return `${location.protocol}//${location.host}${this.base_uri}preview`
  }

  get contentEscapeHtml(): string {
    const c = this.content + ''
    return c.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
  }

  get className(): string {
    return ''
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      publish_at: this.publish_at,
      status: this.status,
      content: this.content,
      thumbnail_id: this.thumbnail?.id || null,
      seo_title: this.seo_title,
      seo_description: this.seo_description,
      seo_ogp_title: this.seo_ogp_title,
      seo_ogp_description: this.seo_ogp_description,
      seo_ogp_image_url: this.seo_ogp_image_url,
      seo_ogp_twitter_image_url: this.seo_ogp_twitter_image_url,
      tag_ids: this.tags.map(t => t.id),
    }
  }
}
